import React, { useState, useEffect } from 'react';
import './Notification.css';
import { useSelector, useDispatch } from 'react-redux';
import { setMessage } from 'store/slice/HeaderSlice';
import Notification from './Notification';

const NotificationMgr = () => {
    const dispatch = useDispatch();
    const {message} = useSelector((state) => state.headerslice);
    const [notification, setNotification] = useState({ message: '', visible: false });

    useEffect(() => {   
        showNotification()
    }, [message]);

    const hideNotification = () => {
        setNotification({ message: '', visible: false });
        dispatch(setMessage(''));
    }

    const showNotification = () => {
        setNotification({ message, visible: true });
        setTimeout(() => {
            hideNotification();
        }, 5000);
    };

    // useEffect(() => {
    //     if (notification.visible) {
    //         const timer = setTimeout(() => {
    //             // Logic to hide the notification can be implemented here
    //         }, 5000);
    //         return () => clearTimeout(timer);
    //     }
    // }, [notification.visible]);

    return (
        <>
        <Notification notification={notification}/>
        </>

        
    );
};

export default NotificationMgr;